"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function NewDiamond(props) {
  return _react2["default"].createElement(
    "svg",
    { className: props.className, width: props.size, height: props.size, viewBox: "0 0 64 64", xmlns: "http://www.w3.org/2000/svg" },
    _react2["default"].createElement("path", { d: "M63.7388424,17.6647012 L53.6960572,0.92772814 C53.3556236,0.35973132 52.7314956,6.82121028e-13 52.069542,6.82121028e-13 L12.617093,6.82121028e-13 C11.9551392,6.82121028e-13 11.3310113,0.340798093 10.9905779,0.92772814 L0.947792456,17.6647012 C0.493881248,18.403097 0.626272016,19.3686916 1.23148696,19.9745549 L31.0004968,49.7754548 C31.7381026,50.5138508 32.9296194,50.5138508 33.6672252,49.7754548 L63.4362352,19.9745549 C64.0603628,19.3686916 64.1738408,18.403097 63.7388424,17.6647012 Z M48.8165116,24.064132 L33.6861381,39.2107139 C33.3078788,39.5704452 32.8350546,39.7597775 32.3433175,39.7597775 C31.8515804,39.7597775 31.3787562,39.5704452 31.0004968,39.2107139 L15.8701233,24.064132 C15.1325176,23.3257362 15.1325176,22.1329428 15.8701233,21.394547 C16.607729,20.6561511 17.799246,20.6561511 18.5368516,21.394547 L32.3433175,35.1968697 L46.1308704,21.394547 C46.868476,20.6561511 48.0599928,20.6561511 48.7975988,21.394547 C49.5352044,22.1329428 49.5541172,23.3257362 48.8165116,24.064132 Z", fill: "#FF6600" })
  );
}

exports["default"] = NewDiamond;
module.exports = exports["default"];